(function () {

	angular.module('suave-ui', [
		'su-templates',
		'su-grid',
		'su-form',
		'su-button',
		'su-layers',
		'su-snackbar'
	]);

})();
